import { InputAdornment, TextField } from '@mui/material';
import { useField } from 'formik';
import React, { useEffect, useState } from 'react';

function formatCurrency(value) {
  const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));
  if (isNaN(numericValue)) {
    return '';
  }
  return numericValue.toFixed(2);
}

function CurrencyTextField({ value, onChange, onBlur, InputProps, ...props }) {
  const [inputValue, setInputValue] = useState(value);

  const handleChange = event => {
    const rawValue = event.target.value;
    setInputValue(rawValue);
    onChange && onChange(event);
  };

  const handleBlur = event => {
    const formattedValue = formatCurrency(event.target.value);
    setInputValue(formattedValue);
    if (onChange) {
      onChange({
        target: {
          name: event.target.name,
          value: formattedValue,
        },
      });
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  // Synchronize inputValue with the value prop when it changes
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <TextField
      {...props}
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        ...InputProps,
      }}
    />
  );
}

function FormikCurrencyTextField({ name, ...props }) {
  const [field, meta, helpers] = useField(name);

  const handleChange = event => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  const handleBlur = event => {
    const formattedValue = event.target.value;
    helpers.setValue(formattedValue);
    helpers.setTouched(true);
    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  return (
    <CurrencyTextField
      {...field}
      {...props}
      onChange={handleChange}
      onBlur={handleBlur}
      error={meta.touched && Boolean(meta.error)}
      helperText={(meta.touched && meta.error) || props.helperText}
    />
  );
}

export { FormikCurrencyTextField };

export default CurrencyTextField;
